import React, { useState } from "react";
import styles from '../index.module.css';
import LoginLogo from '../../../../assets/images/brand/study_hub_logo.png';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotPwSubmit } from "../../../../redux/features/auth/authService";
import BeatLoader from "react-spinners/BeatLoader";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isEmailSending, emailSendMsg } = useSelector((state) => state.auth.sendEmail)

    const [formData, setFormData] = useState({
        email: '',
    });

    const [errorMessages, setErrorMessages] = useState({
        email: '',
    });

    const [responseMsg, setResponseMsg] = useState('');
    const [isSuccess, setSuccess] = useState(true);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrorMessages((prev) => ({
            ...prev,
            [name]: '',
        }));
        setResponseMsg('');
    };

    const validateFormData = () => {
        const errors = {};
        if (!formData.email) {
            errors.email = 'Email is required.'
        }
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return false;
        } else {
            return true;
        }
    }

    const sendEmail = async () => {
        try {
            if (validateFormData()) {
                const response = await dispatch(forgotPwSubmit(formData)).unwrap();
                if (response.success === true) {
                    setSuccess(true);
                    setResponseMsg(response.message);
                }
            }
        } catch (error) {
            setSuccess(false);
            setResponseMsg(error.message);
        }
    }

    const goHome = () => {
        navigate('/');
    }

    return (
        <div className={styles.authContainer}>
            <div className={styles.authCard}>
                <div className={styles.authCardHeader}>
                    <img src={LoginLogo} alt="Logo" className={styles.logoImg} onClick={goHome} />
                    <h1 className={styles.authTitle} style={{ marginBottom: '15px' }}>Forgot Password?</h1>
                </div>
                <div className={styles.authCardBody}>
                    <div className={styles.formContainer}>
                        <form noValidate>
                            <div className={`form-input-row`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Email Address
                                    </label>
                                    <input
                                        type='text'
                                        id='email'
                                        name='email'
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder='Enter your email address'
                                        className={`form-input-default`}
                                    />
                                    {errorMessages.email && (
                                        <p className={`text-danger`}>{errorMessages.email}</p>
                                    )}
                                </div>
                            </div>
                            {responseMsg && (
                                        <p className={isSuccess? `text-success` : `text-danger`}>{responseMsg}</p>
                                    )}
                            <button
                                className={styles.authBtn}
                                type='button'
                                disabled={isEmailSending}
                                onClick={sendEmail}
                            >
                                {isEmailSending ? <BeatLoader color='#ffffff' /> : `Send`}

                            </button>
                        </form>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default ForgotPassword;